module.exports = function () {
    if ($('.feature-grid-and-list').length) {
        var resizeListContainer = function() {
            $('.feature-grid-and-list-list-container').each(function () {
                var $innerContainer = $(this).children().last();
                var newHeight = $innerContainer.outerHeight() + $innerContainer.position().top + 32;
                $(this).css('height', newHeight + 'px');
            });
        };

        resizeListContainer();
        setTimeout(resizeListContainer, 100);
        $(window).resize(resizeListContainer);

        $('.feature-grid-and-list-expand-button').click(function () {
            var $container = $(this).parents('.feature-grid-and-list').first().find('.feature-grid-and-list-list-container');
            var openClass = 'feature-grid-and-list-list-container-open';
            var isClosing = $container.hasClass(openClass);
            $container.toggleClass(openClass);
            $(this).toggleClass('feature-grid-and-list-expand-button-open');
            $(this).find('span').text(isClosing ? $(this).data('showText') : $(this).data('hideText'));
            $(this).blur();
            return false;
        });
    }
};